import { combineReducers } from 'redux'
import video from './video';
import auth from './auth';
import user from './user';
import image from './image';

export default combineReducers({ video, auth, user, image });
